






























import ModalVideoPlayer from "@/components/modal/ModalVideoPlayer/ModalVideoPlayer.vue";
import { GetCookie, SetCookie } from "@/helper/shareHelper";
import { GetYoutubeUrlFromPageName } from "@/helper/youtubeHelper";
import { UserModel } from "@/model/user/userModel";
import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

const StoreAuthentication = namespace("Authentication");

@Component({ components: { ModalVideoPlayer } })
export default class VideoPlayer extends Vue {
  private isShowVideo = false;
  private iframe = "";
  private youtubeUrlList: any = [];
  private showModalVideoPlayer = false;

  @StoreAuthentication.Getter
  public getUserInfo!: UserModel | null;

  created() {
    this.SetVideoIframe();
  }

  @Watch("showModalVideoPlayer")
  showModalVideoPlayerChane(newVal: Boolean) {
    if (!newVal) {
      this.isShowVideo = true;
    }
  }

  public SetVideoIframe() {
    this.youtubeUrlList = GetYoutubeUrlFromPageName();
    if (this.youtubeUrlList && this.youtubeUrlList.length > 0) {
      this.youtubeUrlList[0].isShow = true;
      this.SetIframe(this.youtubeUrlList[0].url);
    }
  }
  public ShowVideo(youtubeIndexItem: any) {
    this.youtubeUrlList.forEach((youtube: any, index: number) => {
      if (index == youtubeIndexItem) {
        this.SetIframe(youtube.url);
        youtube.isShow = !youtube.isShow;
      } else {
        youtube.isShow = false;
      }
    });
  }
  public SetIframe(url: string) {
    this.iframe = `<iframe width="300" height="168.73" src="${url}" title="YouTube video player" frameborder="0"  clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
  }
  public ShowModalVideoPlayer() {
    this.isShowVideo = false;
    this.showModalVideoPlayer = true;
  }
}
